import { useState } from 'react';
import { call } from '../funcStore';
import { TRENDING_RANGE_OPTIONS } from '../api/mockApi';
import { logAction } from '../api/logApi';
import Header from '../components/Header';
import Footer from '../components/Footer';
import VTuberCard from '../components/VTuberCard';
import TrendingVideoCard from '../components/TrendingVideoCard';

const styles = {
  page: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  homeMain: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '32px',
    padding: '24px',
  },
  homeHero: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    textAlign: 'center',
    maxWidth: '480px',
  },
  homeTitle: {
    margin: 0,
    fontSize: '2rem',
  },
  homeDescription: {
    margin: 0,
    color: '#555',
  },
  submitButton: {
    marginTop: '8px',
    padding: '10px',
    border: 'none',
    borderRadius: '4px',
    background: '#4b3f8f',
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  homeSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    maxWidth: '960px',
  },
  homeSectionTitle: {
    margin: 0,
    fontSize: '1.25rem',
  },
  homeSectionDescription: {
    margin: 0,
    color: '#555',
    fontSize: '0.9rem',
  },
  resultGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
    gap: '16px',
  },
  trendingHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
  },
  trendingTabs: {
    display: 'flex',
    gap: '8px',
  },
  trendingTab: {
    border: '1px solid #ddd',
    background: '#fff',
    borderRadius: '16px',
    padding: '4px 14px',
    fontSize: '0.85rem',
    color: '#555',
    cursor: 'pointer',
  },
  trendingTabActive: {
    border: '1px solid #4b3f8f',
    background: '#4b3f8f',
    color: '#fff',
  },
};

const FEATURED_IDS = ['1', '3', '5'];

const TRENDING_DISPLAY_LIMIT = 6;

function HomePage() {
  const [trendingRange, setTrendingRange] = useState(
    TRENDING_RANGE_OPTIONS[0].value
  );

  const handleStartClick = () => {
    call('app.navigateToSearch');
  };

  const trendingVideos =
    call('app.getTrendingVideos', trendingRange)?.slice(
      0,
      TRENDING_DISPLAY_LIMIT
    ) || [];

  return (
    <div style={styles.page}>
      <Header />

      <main style={styles.homeMain}>
        <div style={styles.homeHero}>
          <h1 style={styles.homeTitle}>VTuber発見・検索サービス</h1>
          <p style={styles.homeDescription}>
            VTuberの情報をDB化し、配信傾向や特徴から自分好みのVTuberを検索・発見できるサービスです。
          </p>
          <button
            type="button"
            style={styles.submitButton}
            onClick={handleStartClick}
          >
            VTuberを検索する
          </button>
        </div>

        <section style={styles.homeSection}>
          <div style={styles.trendingHeader}>
            <h2 style={styles.homeSectionTitle}>急上昇</h2>
            <div style={styles.trendingTabs}>
              {TRENDING_RANGE_OPTIONS.map(({ value, label }) => (
                <button
                  key={value}
                  type="button"
                  style={{
                    ...styles.trendingTab,
                    ...(trendingRange === value ? styles.trendingTabActive : {}),
                  }}
                  onClick={() => {
                    logAction('trending_tab_click', { range: value });
                    setTrendingRange(value);
                  }}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>

          {trendingVideos.length === 0 ? (
            <p style={styles.homeSectionDescription}>
              該当する動画がありません。
            </p>
          ) : (
            <div style={styles.resultGrid}>
              {trendingVideos.map((video) => (
                <TrendingVideoCard key={video.videoId} video={video} />
              ))}
            </div>
          )}
        </section>

        <section style={styles.homeSection}>
          <h2 style={styles.homeSectionTitle}>特集：個人勢VTuber特集</h2>
          <p style={styles.homeSectionDescription}>
            企業に頼らず自分の力で活動する個人勢VTuberをピックアップしました。
          </p>
          <div style={styles.resultGrid}>
            {FEATURED_IDS.map((vtuberId) => (
              <VTuberCard key={vtuberId} vtuberId={vtuberId} />
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default HomePage;
